import React from 'react'
import { IconButton, Typography, Box } from '@mui/material'
import { IconEdit, IconReportSearch } from '../../../../../assets/images/icons'
import { useGlobalStore } from '../../../../../store'
import D3AdaptiveChart from '../D3LineGraph/D3LineGraph'
import ChartLegend from '../ChartLegend/ChartLegend'
import { IconClose } from '../../../../../assets/images/iconsV2'
import {
  GraphContentWrapper,
  GraphContent,
  GraphRow,
  GraphRowDetails,
  GraphContentRow,
  TabCarouselWrapper,
  TabCarousel,
  GraphLevel3,
  IconButtonWrapper
} from './style'
import LhsHeading from '../LhsHeading/LhsHeading'
import BrandImageryRowNewL2 from '../BrandImageryRowNewL2/BrandImageryRowNewL2'
import CustomTabs from '../../../../../components/customTabs'

const BrandImageryRowNew = ({
  isExportToPptWithProgression,
  row,
  index,
  canMove = false,
  editTitleFlag,
  editTitleClicked,
  showLevel2Func,
  showExpandAllCTA,
  showTabContent,
  progressionDataFiltered,
  totalPeriods
}) => {
  const { showLhsMenu } = useGlobalStore()

  if (!progressionDataFiltered.drivers.includes(row.title)) { return false } // WORKING

  const filteredRowDataBrands = [...row?.data]?.filter((d) => progressionDataFiltered.brands.includes(d.logoName)) || []
  const filteredRowData = filteredRowDataBrands.map((d) => ({
    ...d,
    periodArray: d.periodArray?.filter((p) => progressionDataFiltered.periods.includes(p)) || [],
    scaleArray: d.scaleArray?.filter((s) => progressionDataFiltered.periods.includes(s.periodLabel)) || []
  })) || []
  
  if (filteredRowData.length === 0) {
    return false
  }

  return (
    <GraphContentWrapper
      className={`${row?.showLevel2 && row?.nestedData?.length > 0 ? 'showRowLevel2' : ''}`}
    >
      <GraphContent
        className={`brandImageryRowAppendices brandImageryRowProgression brandImageryRow tRow aaaaaaaaaaa ${row?.nestedData?.length > 0 ? 'brandImageryLevel2' : 'brandImageryLevel1'}`}
      >
        <GraphRow className='list'>
          <GraphContentRow>
            <LhsHeading row={row} level={2} />
            {editTitleFlag && false && (
              <IconButton
                aria-label='Edit'
                onClick={() => editTitleClicked(row)}
                sx={{ height: '35px', margin: '-5px 0 0 5px' }}
              >
                <IconEdit />
              </IconButton>
            )}
            <GraphRowDetails className='graphRowDetails'>
              {row?.nestedData?.length > 0 && (
                <IconButton size='small' onClick={() => showLevel2Func(row, index)}>
                  <IconReportSearch />
                </IconButton>
              )}
            </GraphRowDetails>
          </GraphContentRow>

          <D3AdaptiveChart data={filteredRowData} progressionDataFiltered={progressionDataFiltered} />
          <ChartLegend data={filteredRowData} type='brand' />
        </GraphRow>
      </GraphContent>
      {row?.nestedData && (
        <GraphLevel3
          className='brandImageryRow details' style={{ display: row?.showLevel2 ? 'block' : 'none' }}>
          {!isExportToPptWithProgression && row.nestedData.length > 0 && (
            <Box>
              <Box style={{position:'relative', padding:'5px 0'}}>
                {row.title}
                <IconButtonWrapper
                  variant='outlined'
                  color='light'
                  startIcon={<IconClose />}
                  onClick={() => showLevel2Func(row, index)}
                  style={{top:'-3px', right:'-3px'}}
                />
              </Box>
              <TabCarouselWrapper lhsMenu={showLhsMenu}>
                <CustomTabs
                  options={row.nestedData.map((item, idx) => ({
                    id: idx,
                    label: <>{item.title} <b>{item.per}%</b></>
                  }))}
                  onChange={(idx) => showTabContent(row.nestedData[idx], index)}
                  value={row.nestedData.findIndex((item) => item.show)}
                  styletype='themeV2'
                />
              </TabCarouselWrapper>

              {row.nestedData
                .filter((f) => f.show)
                .map((rowDataL2, index4) => (
                  <BrandImageryRowNewL2
                    key={index4}
                    parentRow={row}
                    row={rowDataL2}
                    progressionDataFiltered={progressionDataFiltered}
                    totalPeriods={totalPeriods}
                  />
                ))}
              <ChartLegend data={filteredRowData} type='brand' />
            </Box>
          )}

          {isExportToPptWithProgression && row.nestedData.length > 0 && (
            <Box>
              {row.nestedData.map((rowDataL2, index4) => (
                <BrandImageryRowNewL2
                  isExportToPptWithProgression={isExportToPptWithProgression}
                  key={index4}
                  parentRow={row}
                  row={rowDataL2}
                  progressionDataFiltered={progressionDataFiltered}
                  totalPeriods={totalPeriods}
                />
              ))}
            </Box>
          )}
        </GraphLevel3>
      )}
    </GraphContentWrapper>
  )
}

export default BrandImageryRowNew
